/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Row , Col} from 'react-bootstrap'
import Vocabulary from '../components/custom_content/vocabulary_edit.js'


export default class EditContent extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:this.props.match.params.tab,
            id:this.props.match.params.id,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(props){

    }

    onNavigationSelect(eventKey){
        window.location.hash = "library/"+eventKey;
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({
            tab:this.props.match.params.tab,
        })
    }

    getBody(){

        switch(this.state.tab)
        {
            case "vocabulary" : return <Vocabulary/>
            default: return null;
        }

    }

    render(){

        return <div>
                    <Row>
                        <Col md={12}>
                                <Vocabulary catalogUID={this.state.id} />
                        </Col>
                    </Row>
                </div>


    }

}